import React from 'react';
import { paths } from '@src/constants/pathsEnum';

import { p4 } from './payload';
import { ProductSection } from '../../spe-ne';

import { Button } from '@commons/button/Button';

import * as styles from './p4-section.module.scss';

export const P4Section = () => (
  <>
    <ProductSection id="spe-p4" title="P4" payload={p4} background="black" arrowType="lime-arrow">
      <Button className={styles.button} label="Learn more" href={paths.SERVICES.P4} rel="nofollow" />
    </ProductSection>
  </>
);
